import React from "react";
import BreadCrumb from "../../BreadCrumb";
import data from "../../dataPoint/AllShopProducts";
import PageHeader from "../PageHeader/PageHeader";


function DesignerPage(props) {

  const  product  = data.products.find((x) => x._ === props.match.params.category)
  return (
    <div>
      <PageHeader title={product.brand}/>
      <BreadCrumb pagename={product.category} />
      <div>
          <h1>
           {product.title_}
          </h1>
      </div>
    </div>
  );
}

export default DesignerPage;
